import { Directive, HostBinding, Input } from '@angular/core';
import { NgForm, NgModel } from '@angular/forms';
import { BootstrapFormDirective } from './bootstrap-form.directive';

/**
 * Applies .is-valid or .is-invalid CSS classes to Bootstrap
 * form inputs based on NgForm and NgModel state.
 */
@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: `
    '.form-control[ngModel]',
    '.form-control-file[ngModel]',
    '.form-check-input[ngModel]',
    '.form-select[ngModel]',
    'th-datetime-picker[ngModel],
    'ckeditor[ngModel],
    'ng-select[ngModel]'
  `
})
export class BootstrapFormInputsDirective {
  /**
   * Set to `true`to apply validation classes as soon as the input becomes dirty.
   */
  @Input() eagerValidation = false;

  constructor(
    private ngModel: NgModel,
    private ngForm: NgForm,
    private bootstrapFormDirective: BootstrapFormDirective
  ) {}

  @HostBinding('class.is-valid')
  get validStyle(): boolean {
    if (this.bootstrapFormDirective.showValidationClasses) {
      return ((this.ngModel.dirty && this.eagerValidation) || this.ngForm.submitted) && this.ngModel.valid;
    }

    return false;
  }

  @HostBinding('class.is-invalid')
  get invalidStyle(): boolean {
    if (this.bootstrapFormDirective.showValidationClasses) {
      return ((this.ngModel.dirty && this.eagerValidation) || this.ngForm.submitted) && this.ngModel.invalid;
    }

    return false;
  }
}
